import React from "react";
import { toast } from "sonner";

const AppleGlyph = ({ className = "h-7 w-7" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.53 4.08zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);

const PlayGlyph = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M2.6 2.63A1.9 1.9 0 0 0 2.4 3.5v17c0 .31.07.6.2.87L12.2 12 2.6 2.63z" fill="#00A0FF" />
    <path d="M3.91 1.31a1.9 1.9 0 0 1 1.59-.11l10.62 6.07-2.62 2.63L3.91 1.31z" fill="#00E177" />
    <path d="M13.5 13.1l2.62 2.63L5.5 21.8a1.9 1.9 0 0 1-1.59-.11L13.5 13.1z" fill="#FF3A44" />
    <path d="M20.6 10.6a1.62 1.62 0 0 1 0 2.12l-.03.02-3.1 1.77-2.85-2.85 2.85-2.85 3.13 1.79z" fill="#FFCE00" />
  </svg>
);

/** The two official store badges, reproduced in the standard black lockup. */
const Badge = ({ store, href }) => {
  const ios = store === "ios";
  const label = ios ? "App Store" : "Google Play";
  const live = !!href;
  const open = () => {
    if (live) window.open(href, "_blank", "noopener");
    else toast.info(`${label} — coming soon`, {
      description: "The Tharwy app is in store review. Open a free account now and it'll be waiting for you.",
    });
  };
  return (
    <button onClick={open} data-testid={`store-badge-${store}`} aria-label={`Get Tharwy on ${label}`}
      className="group inline-flex h-[46px] items-center gap-2.5 rounded-[9px] border border-white/25 bg-black px-3.5
                 text-white transition-transform duration-200 hover:-translate-y-0.5 hover:border-white/50
                 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60">
      {ios ? <AppleGlyph className="h-[26px] w-[26px] -mt-[3px]" /> : <PlayGlyph className="h-[23px] w-[23px]" />}
      <span className="text-start leading-none">
        <span className="block text-[9px] font-normal tracking-[0.02em] text-white/95">
          {ios ? "Download on the" : "GET IT ON"}
        </span>
        <span className="mt-[3px] block text-[17px] font-medium leading-none tracking-[-0.01em]">{label}</span>
      </span>
    </button>
  );
};

export const StoreBadges = ({ appStoreUrl, playStoreUrl }) => (
  <div className="flex flex-wrap items-center gap-3" data-testid="app-store-badges">
    <Badge store="ios" href={appStoreUrl} />
    <Badge store="android" href={playStoreUrl} />
  </div>
);
